import { BaseService } from './BaseService';
import { ApolloQueryResult } from 'apollo-client';
import { searchPorts, TransportationTypeEnum } from '@/types/graphql/schemaTypes';
import fetchPorts from '@/graphql/queries/FetchPorts.gql';

class PortService extends BaseService {
  public fetchPorts(searchText: string, transportationType?: TransportationTypeEnum | null):
  Promise<ApolloQueryResult<searchPorts>> {
    let placeType: string | null = null;

    switch (transportationType) {
      case TransportationTypeEnum.sea:
        placeType = 'port';
        break;
      case TransportationTypeEnum.air:
        placeType = 'airport';
        break;
      default:
        break;
    }

    return this.client.query({
      query: fetchPorts,
      variables: {
        placeType,
        nameSearch: searchText
      }
    });
  }
}

export const portService = new PortService();
